import { ComparerSummaryID, ComparerResults as TypeComparerResults } from '@/types/comparer';
import { Table, TableBody } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import CommonCategoriesChanges from '../comparerCategories/CommonCategoriesChanges';
import CommonChanges from '../comparerCategories/CommonChanges';
import MetadataChanges from '../comparerCategories/MetadataChanges';
import NoChangesFound from '../comparerShared/NoChangesFound';
import NodesChanges from '../comparerCategories/NodesChanges';
import PromptsChanges from '../comparerCategories/PromptsChanges';
import SubroutinesChanges from '../comparerCategories/SubroutinesChanges';
import VariablesChanges from '../comparerCategories/VariablesChanges';

type ComparerResultsProps = {
  results: TypeComparerResults | undefined;
  selected: ComparerSummaryID;
};

const ComparerResults: FC<ComparerResultsProps> = ({ results, selected }) => {
  const loadContent = () => {
    if (!results) return;

    switch (selected) {
      case 'metadata':
        return <MetadataChanges metadata={results.metadata} />;

      case 'subroutines':
        return <SubroutinesChanges subroutines={results.subroutines} />;

      case 'nodes':
        return <NodesChanges subroutines={results.subroutines} />;

      case 'variables':
        return <VariablesChanges subroutines={results.subroutines} variables={results.variables} />;

      case 'prompts':
        return <PromptsChanges prompts={results.prompts} />;

      case 'common':
        return <CommonCategoriesChanges results={results} />;

      case 'folders':
        return <CommonChanges categories={results.folders} />;

      default:
        return <NoChangesFound />;
    }
  };

  return (
    <Box width={'100%'} overflow='auto'>
      <Table>
        <colgroup>
          <col style={{ width: '23%' }} />
          <col style={{ width: '38%' }} />
          <col style={{ width: '38%' }} />
        </colgroup>
        <TableBody sx={{ border: 1, borderColor: 'divider' }}>{loadContent()}</TableBody>
      </Table>
    </Box>
  );
};

export default ComparerResults;
